import(/* webpackMode: "eager" */ "/app/src/app/(public)/insurance/page.tsx");
